export default __webpack_public_path__ + "static/how_it_works_step_5_desktop_tablet-acb222832cc02e8a8f391e3e38b3ae6d.webp";